<template>
  <div v-on:keydown.stop>
    <v-data-table
      v-if="items"
      :headers="headers"
      :items="items"
      :items-per-page="-1"
      :search="search"
      :custom-filter="filterOnRelease"
      :custom-key-sort="customSort"
      :group-by="releaseNoAssigned(items) ? groupBy : []"
      :group-header="false"
      :class="releaseNoAssigned(items) ? 'hide-first-column ' : ''"
      style="padding-top: 40px;"
      must-sort
      ref="sortableTable"
    >
      <template v-slot:bottom></template>

      <template v-slot:no-data>
        <!-- replaced by <card-quick-add /> -->
      </template>

      <template #group-header="props">
        <td
          colspan="8"
          class="release-row"
          :data-release-no="props.group"
        >
          {{ props.isGroupOpen(props.item) ? '' : props.toggleGroup(props.item) }}
          <quick-rename-input
            :value="getReleaseName(props.item.value)"
            :title="$store.state.isWorkflowDisabled ? '' : 'Click to edit release name'"
            :disabled="$store.state.isWorkflowDisabled || !props.item.value"
            @onChange="saveReleaseName(props.item.value, $event)"
            class="release-name-display"
            density="2"
            :maxLength="30"
          />
          <add-card-button
            v-if="!showDone && $route.params.eventId && defaultCardType?.title"
            :disabled="$store.state.isWorkflowDisabled"
            @click="addCardAtTopOfRelease(props.item.value)"
            class="release-add-btn"
            compact
          >
            <template #label>
              Add <b>{{ defaultCardType?.title }}</b>
            </template>
          </add-card-button>
        </td>
      </template>

      <template #item="props">
        <tr
          class="sortableRow"
          :key="props.item.id + props.item.sortkey + props.item.releaseNo"
          :id="props.item.id"
          :data-sortkey="props.item.sortkey"
          :data-workflow-event-id="props.item.eventId"
          :data-release-no="props.item.releaseNo"
        >
          <td class="text-center row-number">
            {{ idIndexMap[props.item.id] + 1 }}
          </td>

          <td class="px-1 text-center">
            <v-btn
              style="cursor: move"
              icon="mdi-drag-horizontal-variant"
              class="table-btn sortHandle"
              tabindex="-1"
              :disabled="$store.state.isWorkflowDisabled"
            >
            </v-btn>
          </td>

          <td
            class="text-left description-column"
          >
            <div class="mt-3">
              <card-description
                :item="props.item"
                :event="findEventFromCardId(props.item.id)"
                :creator="props.item.creator"
                :jiraData2="jiraData2"
                :loadingJiraInfo="loadingJiraInfo"
                :showAi="true"
                :show-comments-count="true"
                :showEntitySelector="true"
                @ask-for-reply="onAskForReply($event, props.item)"
                withDates
                replyWithDates
                hide-type-selector
                hide-release-selector
              >
                <card-description-field
                  :item="props.item"
                  :index="idIndexMap[props.item.id] * 3 + 1"
                  :focus-card="focusCard"
                  @move-focus="moveFocus"
                  :scrollIntoViewArg="true"
                ></card-description-field>
              </card-description>
            </div>
          </td>

          <!-- <td class="text-center">
            <users-menu
              :card-id="props.item.id"
              :items="teamMembersList"
              :selected="props.item.assignee?.id"
              @change="$emit('assign-card', props.item, $event)"
            ></users-menu>
          </td> -->

          <td
            class="text-center"
            @click="focusOnTabindex(idIndexMap[props.item.id] * 3 + 2)"
          >
            <card-type-selector
              :card="props.item"
              :tabIndex="idIndexMap[props.item.id] * 3 + 2"
              @keydown-card-type="keydownCardType"
            />
          </td>

          <td
            class="text-center"
            @click="focusOnTabindex(idIndexMap[props.item.id] * 3 + 3)"
          >
            <release-selector
              :card="props.item"
              :tabIndex="idIndexMap[props.item.id] * 3 + 3"
              @keydown-release-no="keydownReleaseNo"
            />
          </td>

          <td
            class="text-left"
            @click="!$store.state.isWorkflowDisabled && openDialog(props.item)"
            style="cursor: pointer; font-size: 13px; font-weight: 400;"
          >
            {{ formatEventName(props.item.eventId) }}
          </td>

          <td class="text-right actions-on-cards" style="white-space: nowrap">
            <v-menu style="z-index: 99999;">
              <template #activator="{ props: btnProps }">
                <v-btn v-bind="btnProps" tabindex="-1" variant="text" size="small" class="table-btn" icon="mds:more-horiz"/>
              </template>

              <v-list>
                <!-- <v-list-item
                  :disabled="$store.state.isWorkflowDisabled"
                  @click="$emit('open-card-dialog', props.item)"
                >
                  <template v-slot:prepend>
                    <v-icon color="grey">mdi-message-text</v-icon>
                  </template>

                  <v-list-item-title>Votes</v-list-item-title>
                </v-list-item> -->

                <v-list-item
                  :disabled="$store.state.isWorkflowDisabled"
                  @click="duplicateCard(props.item)"
                >
                  <template v-slot:prepend>
                    <v-icon color="grey">mdi-content-copy</v-icon>
                  </template>

                  <v-list-item-title>Duplicate</v-list-item-title>
                </v-list-item>

                <workflow-delete-item-dialog
                  #default="{ props: deleteBtnProps }"
                  :itemType="'Card'"
                  :card="props.item"
                >
                  <v-list-item v-bind="deleteBtnProps"
                               :disabled="$store.state.isWorkflowDisabled">
                    <template v-slot:prepend>
                      <v-icon color="grey">mdi-delete</v-icon>
                    </template>
                    <v-list-item-title>Delete</v-list-item-title>
                  </v-list-item>
                </workflow-delete-item-dialog>

                <v-list-item
                  :disabled="$store.state.isWorkflowDisabled"
                  @click="
                    $emit('item-actions-done', props.item, !props.item.done)
                  "
                >
                  <template v-slot:prepend>
                    <v-icon color="grey">{{
                      props.item.done ? "mdi-undo" : "mdi-check"
                    }}</v-icon>
                  </template>

                  <v-list-item-title>{{
                    props.item.done ? "Reopen" : "Done"
                  }}</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </td>
        </tr>
      </template>
    </v-data-table>
    <card-quick-add
      @focus-card="focusCard = $event.id"
    />
    <!-- Change event dialog -->
    <v-dialog v-model="dialog" max-width="500px" persistent>
      <v-card>
        <v-row fluid justify-space-between align-top>
          <v-col>
            <!-- if new -->
            <v-card-title>
              <span class="text-h5">Move card</span>
            </v-card-title>
            <v-card-subtitle v-if="editCard" class="pt-0">
              From: <b>{{ formatEventName(editCard.eventId) }}</b>
            </v-card-subtitle>
          </v-col>
          <v-col class="flex-shrink-1 flex-grow-0">
            <v-btn variant="text" icon color="grey" @click="closeDialog">
              <v-icon >mdi-close</v-icon>
            </v-btn>
          </v-col>
        </v-row>
        <v-card-text style="padding: 0">
          <v-container grid-list-md>
            <v-form ref="form" v-model="validEvents">
              <v-row wrap>
                <v-col cols="12" v-if="moveTargetEvents?.length > 0">
                  <v-autocomplete
                    :rules="[rules.required]"
                    ref="sequenceInput"
                    v-model="eventId"
                    v-model:search="eventSearch"
                    :items="moveTargetEvents"
                    :hide-no-data="false"
                    hide-details="auto"
                    color="blue-grey-lighten-2"
                    label="Move to event"
                    placeholder="Type to search…"
                    :item-title="formatValidTargets"
                    item-value="id"
                    variant="outlined"
                    density="compact"
                    clearable
                    open-on-clear
                    auto-select-first
                    no-data-text="No matching events"
                  >
                  </v-autocomplete>
                </v-col>
                <v-col cols="12" v-else> No valid targets </v-col>
              </v-row>
            </v-form>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            rounded="lg"
            size="large"
            variant="outlined"
            color="gray"
            @mousedown.prevent="closeDialog"
            @click="closeDialog"
          >Cancel</v-btn>
          <v-btn
            rounded="lg"
            size="large"
            variant="flat"
            color="primary"
            class="move-card"
            :disabled="isMoveCardDisabled"
            :loading="movingCard"
            @click="moveCard"
          >{{
            "Move card"
          }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Sortable from 'sortablejs'
import AddCardButton from '@/components/AddCardButton'
import CardDescription from '@/components/CardDescription'
import CardDescriptionField from '@/components/CardDescriptionField'
import WorkflowDeleteItemDialog from '@/components/WorkflowDeleteItemDialog'
import CardTypeSelector from '@/components/CardTypeSelector'
import ReleaseSelector from '@/components/ReleaseSelector'
import workflowApi from '@/api/workflowApi'
import { cardHelpers } from '@/mixins/cardHelpers.js'
import cardHelpers2 from '@/helpers/cardHelpers.js'
import { mapGetters, mapState } from 'vuex'
import CardQuickAdd from '@/components/CardQuickAdd'
import QuickRenameInput from '@/components/QuickRenameInput'

export default {
  components: {
    CardDescription,
    CardDescriptionField,
    WorkflowDeleteItemDialog,
    CardTypeSelector,
    ReleaseSelector,
    CardQuickAdd,
    QuickRenameInput,
    AddCardButton
  },

  mixins: [cardHelpers],

  props: {
    items: Array,
    events: Object,
    idIndexMap: Object,
    roleName: String,
    computeAverage: Function,
    bpmn: Object,
    search: String,
    workflow: Object,
    jiraData2: Object,
    loadingJiraInfo: Number,
    showDone: Boolean
  },

  data () {
    return {
      // commented the following row because it looks like it's not needed
      // if you need it, also add :key="tableKey" to the v-data-table tag
      // and the watcher and the method refreshTable
      // tableKey: 0, // Initial key
      prioDescriptions: ['Must have', 'Should have', 'Could have', 'Won\'t have'],
      menu: {},
      menuPrio: {},
      dialog: false,
      validEvents: true,
      rules: { required: value => !!value || 'Required.' },
      eventId: null,
      eventSearch: '',
      editCard: null,
      movingCard: false,
      groupBy: [{ key: 'releaseIndex', order: 'desc' }],
      headers: [
        { title: 'Row', align: 'left', value: 'sortkey', sortable: false, width: '1%', key: 'row' },
        { title: 'Reorder', align: 'left', sortable: false, width: '1%', key: 'reorder' },
        { title: 'Description', align: 'left', sortable: false, width: '30%', value: 'description', key: 'description' },
        // { title: 'Assignee', align: 'center', sortable: false, width: '10%' },
        { title: 'Type', align: 'center', sortable: false, value: 'cardType.title', width: '13%', key: 'type' },
        { title: 'Release', align: 'center', sortable: false, width: '10%', groupable: true, key: 'releaseIndex' },
        // { title: 'My Prio / Team Prio', align: 'center', value: 'prio', sortable: false, width: '10%', key: 'prio' },
        { title: 'Lane / Event', align: 'left', sortable: false, width: '15%', key: 'event' },
        { title: 'Actions', value: 'rank', align: 'right', sortable: false, width: '1%', key: 'actions' }
      ],
      customSort: {
        releaseIndex: (a, b) => {
          const releaseA = a || 9999999999
          const releaseB = b || 9999999999
          return releaseB - releaseA
        }
      },
      focusCard: null
    }
  },

  computed: {
    ...mapGetters({
      baseData: 'svgGraphData/baseData',
      svgLanesData: 'svgGraphData/svgLanesData',
      svgGraphData: 'svgGraphData/svgGraphData',
      svgGroupsData: 'svgGraphData/svgGroupsData',
      defaultCardType: 'cardTypes/defaultCardType'
    }),
    ...mapState({
      cardTypes: state => state.cardTypes.cardTypes
    }),
    moveTargetEvents () {
      const all = this.workflow?.domainEvents || []
      const currentId = this.editCard?.eventId
      return currentId ? all.filter(e => e.id !== currentId) : all
    },
    isMoveCardDisabled () {
      if (this.$store.state.isWorkflowDisabled) return true
      if (this.movingCard) return true
      if (!this.dialog || !this.editCard) return true
      if (!this.moveTargetEvents?.length) return true
      if (!this.eventId) return true
      if (this.eventId === this.editCard.eventId) return true
      return false
    }
  },

  methods: {
    initSortable () {
      this.sortable = new Sortable(this.$refs.sortableTable.$el.getElementsByTagName('tbody')[0], {
        draggable: '.sortableRow',
        handle: '.sortHandle',
        ghostClass: 'sortable-ghost', // Class name for the drop placeholder
        chosenClass: 'sortable-chosen', // Class name for the chosen item
        dragClass: 'sortable-drag',
        animation: window.Cypress ? 0 : 150,
        scroll: true,
        forceFallback: false,
        scrollSensitivity: 100,
        onEnd: this.onEndDrag,
        onStart: function (event) {
          Array.prototype.forEach.call(
            document.querySelectorAll('.v-row-group__header'),
            function (el, index) {
              if (!el.classList.contains('sortableRow') && index !== 0) {
                el.classList.add('sortableRow')
              }
            }
          )
          Array.prototype.forEach.call(
            document.querySelectorAll('.sortableRow:not(.sortable-chosen)'),
            function (el, index) {
              if (!el.classList.contains('white-background-on-hover') && index !== 0) {
                el.classList.add('white-background-on-hover')
              }
            }
          )
        }
      })
    },
    async duplicateCard (item) {
      await workflowApi.createCard(this.$route.params.id, item.eventId, {
        description: item.description,
        cardTypeId: item.cardTypeId,
        releaseNo: item.releaseNo,
        sortkey: cardHelpers2.newSortkeyNextInList(this.workflow, item.sortkey)
      })
    },
    onAskForReply (event, item) {
      const ev = this.events[item.eventId]
      this.$emit('ask-for-reply', Object.assign({}, event, { node: ev }))
    },
    releaseNoAssigned (cards) {
      const index = cards?.findIndex((card) => card.releaseNo !== null)
      return index >= 0
    },
    getReleaseName (releaseValue) {
      if (!releaseValue) {
        return 'No release assigned'
      }
      // Check if there's a custom name in the workflow.releases array
      const release = this.workflow?.releases?.find(r => r.value === parseInt(releaseValue))
      if (release && release.name) {
        return release.name
      }
      return 'Release ' + releaseValue
    },
    async saveReleaseName (releaseValue, event) {
      const newReleaseName = event.target.textContent.trim()

      if (newReleaseName === this.getReleaseName(releaseValue)) {
        return
      }

      if (newReleaseName.length > 30) {
        this.$store.commit('snackbar/showMessage', {
          content: 'Release name must be 30 characters or less',
          color: 'error',
          timeout: 3000
        })
        // Restore the original value
        event.target.textContent = this.getReleaseName(releaseValue)
        return
      }

      try {
        if (newReleaseName.length === 0) {
          const release = this.workflow?.releases?.find((r) => r.value === parseInt(releaseValue))
          if (!release) {
            event.target.textContent = 'Release ' + releaseValue
            return
          }
        }

        await workflowApi.updateReleaseName(
          this.$route.params.id,
          releaseValue,
          newReleaseName
        )
        this.$store.commit('snackbar/showMessage', {
          content: 'Release name updated successfully',
          color: 'success'
        })
      } catch (error) {
        console.error('Error updating release name:', error)
        this.$store.commit('snackbar/showMessage', {
          content: 'Failed to update release name',
          color: 'error'
        })
      }
    },
    formatEventName (eventId) {
      return this.events[eventId]
        ? this.getLaneNameFromId(this.events[eventId].laneId) + ' / ' + this.events[eventId].description
        : ''
    },
    async moveCard () {
      if (!this.editCard) return
      const { valid } = await this.$refs.form?.validate?.() || { valid: false }
      if (!valid || this.isMoveCardDisabled) {
        return
      }

      try {
        this.movingCard = true
        await workflowApi.moveCard(this.$route.params.id, this.$route.params.id, this.eventId, this.editCard.id)
        this.closeDialog()
      } catch (error) {
        console.error('Error moving card:', error)
        this.$store.commit('snackbar/showMessage', {
          content: 'Failed to move card',
          color: 'error',
          timeout: 4000
        })
      } finally {
        this.movingCard = false
      }
    },
    formatValidTargets (item) {
      return this.getLaneNameFromId(item.laneId) + ' — ' + item.description
    },
    getLaneNameFromId (laneId) {
      let res = ''
      const index = this.workflow.lanes.findIndex((lane) => lane.id === laneId)
      if (index >= 0) {
        res = this.workflow.lanes[index].name
      }
      return res
    },
    openDialog (card) {
      this.editCard = card
      // Start with no target selected so typed search doesn't "snap back" to the current event on blur.
      this.eventId = null
      this.eventSearch = ''
      this.dialog = true
      this.$nextTick(() => {
        this.$refs.sequenceInput?.focus?.()
      })
    },
    closeDialog () {
      this.dialog = false
      this.eventId = null
      this.eventSearch = ''
      this.editCard = null
      this.movingCard = false
      this.$refs.form?.resetValidation?.()
    },
    filterOnRelease (_value, search, item) {
      if (typeof search !== 'string' || !search.trim()) {
        return true
      }

      const {
        id,
        description,
        releaseNo,
        cardType,
        status,
        creator,
        eventId
      } = item.raw
      let computedStatus

      if (status) {
        const statusValues = ['mo', 's', 'co', 'w']
        const prioIndex = status.prio - 1
        computedStatus = statusValues[prioIndex]
      }

      const searchFields = [
        id,
        description,
        releaseNo,
        'r' + releaseNo,
        cardType && cardType.title,
        computedStatus,
        creator && `${creator.firstname} ${creator.lastname}`,
        eventId
      ].filter(Boolean).join(' ').toLowerCase()
      const searchText = search.toString().toLowerCase()

      return searchFields.includes(searchText)
    },
    moveFocus (direction, target, className) {
      switch (direction) {
        case 37: // left arrow
        case 'left':
          this.focusOnPreviousTabindex(target)
          break

        case 38: // up arrow
        case 'up':
          this.focusOnPreviousRow(target, className)
          break

        case 39: // right arrow
        case 'right':
          this.focusOnNextTabindex(target)
          break

        case 13: // enter
        case 40: // down arrow
        case 'down':
          this.focusOnNextRow(target, className)
          break
      }
    },
    keydownReleaseNo (event, itemId, fallback) {
      if (!this.menu[itemId]) {
        this.moveFocus(event.keyCode, event.target, 'release-no')
      } else {
        fallback(event)
      }
    },
    keydownCardType (event) {
      this.moveFocus(event.keyCode, event.target, 'card-type')
    },
    focusOnNextRow (target, className) {
      const tr = target.closest('tr')
      let nextTr = tr.nextSibling

      while (nextTr && nextTr.nodeName !== 'TR') {
        nextTr = nextTr.nextSibling
        if (nextTr && nextTr.className === 'v-row-group__header') {
          nextTr = nextTr.nextSibling
        }
      }

      if (nextTr) {
        const nextFocusElement = nextTr.getElementsByClassName(className)[0]
        if (nextFocusElement) {
          nextFocusElement.focus()
        }
      } else {
        target.blur()
        target.focus()
      }
    },
    focusOnPreviousRow (target, className) {
      const tr = target.closest('tr')
      if (tr) {
        let prevTr = tr.previousSibling
        while (prevTr && prevTr.nodeName !== 'TR') {
          prevTr = prevTr.previousSibling
          if (prevTr && prevTr.className === 'v-row-group__header') {
            prevTr = prevTr.previousSibling
          }
        }

        if (prevTr) {
          const prevFocusElement = prevTr.getElementsByClassName(className)[0]
          if (prevFocusElement) {
            prevFocusElement.focus()
          }
        }
      }
    },
    focusOnTabindex (tabindex, event) {
      if (event && event.target.nodeName === 'TEXTAREA') {
        return
      }
      document.querySelector(`[tabindex='${tabindex}']`).focus()
    },
    focusOnPreviousTabindex (target) {
      const prevTabindex = parseInt(target.tabIndex) - 1
      if (prevTabindex > 0) {
        const previousElement = document.querySelector(`[tabindex='${prevTabindex}']`)
        if (previousElement) {
          previousElement.focus()
        }
      }
    },
    focusOnNextTabindex (target) {
      const nextTabindex = parseInt(target.tabIndex) + 1
      if (nextTabindex > 0) {
        const nextElement = document.querySelector(`[tabindex='${nextTabindex}']`)
        if (nextElement) {
          nextElement.focus()
        }
      }
    },
    getCompletedVotesAndComments (teamMembersReactions) {
      let res
      let noOfVotes = 0
      // let noOfComments = 0
      for (const index in teamMembersReactions) {
        if (teamMembersReactions[index]) {
          if (
            teamMembersReactions[index].prio > 0 &&
            teamMembersReactions[index].prio < 5
          ) {
            noOfVotes++
          }

          if (
            teamMembersReactions[index].message &&
            teamMembersReactions[index].message.length > 0
          ) {
            // noOfComments++
          }
        }
      }

      if (noOfVotes === 1) {
        res = '(' + noOfVotes + ' VOTE)'
      } else {
        if (noOfVotes > 0) {
          res = '(' + noOfVotes + ' VOTES)'
        } else {
          res = ''
        }
      }

      // if (noOfComments === 1) {
      //   res += ', ' + noOfComments + ' comment'
      // } else if (noOfComments > 1) {
      //   res += ', ' + noOfComments + ' comments'
      // }

      return res
    },
    onEndDrag (event) {
      this.$emit('drag-reorder', event)
      Array.prototype.forEach.call(
        document.querySelectorAll('.white-background-on-hover'),
        function (el, index) {
          el.classList.remove('white-background-on-hover')
        }
      )
    },
    findEventFromCardId (cardId) {
      const eventId = this.baseData.cardIdToEventIdMap[cardId]
      if (eventId) {
        return this.workflow.domainEvents?.find((event) => event.id === eventId)
      }
      return null
    },
    getFirstCardInRelease (releaseIndex) {
      const cardsInRelease = this.items.filter(card => {
        const cardReleaseIndex = card.releaseNo || 0
        return cardReleaseIndex === releaseIndex
      })

      if (cardsInRelease.length > 0) {
        cardsInRelease.sort((a, b) => {
          const sortA = a.sortkey || 'zzzzzzzzzz'
          const sortB = b.sortkey || 'zzzzzzzzzz'
          if (sortA === sortB) {
            return a.id > b.id ? 1 : -1
          }
          return sortA > sortB ? 1 : -1
        })
        return cardsInRelease[0]
      }
      return null
    },
    async addCardAtTopOfRelease (releaseIndex) {
      try {
        const firstCard = this.getFirstCardInRelease(releaseIndex)
        const sortkey = cardHelpers2.generateNewSortKey('', firstCard?.sortkey || '')
        const releaseNo = releaseIndex === 0 ? null : releaseIndex

        await workflowApi.createCard(
          this.$route.params.id,
          this.$route.params.eventId,
          {
            sortkey,
            releaseNo
          }
        )
      } catch (error) {
        this.$store.commit('snackbar/showMessage', {
          content: 'An error occurred while creating the card',
          color: 'red'
        })
      }
    }
  },
  // commented this part because it looks like it's not needed
  // watch: {
  //   items: {
  //     handler: function (newVal, oldVal) {
  //       // this.refreshTable()
  //     },
  //     deep: true
  //   }
  // },
  mounted () {
    this.initSortable()
  }
}
</script>

<style scoped>

.v-btn.status-button {
  padding: 0 0;
  margin-left: 0;
  margin-right: 0;
  min-width: 40px;
}

.v-btn:not(.v-btn--depressed):not(.v-btn--flat) {
  box-shadow: none;
}

[contenteditable="true"] br {
  display: none;
}

.sortableRow > td:focus-within {
  outline: 2px solid #4d90fe;
}

.fullname {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  text-transform: uppercase;
  font-weight: bold;
  color: var(--light-blue);
}

.btn {
  /* sets the background for the base class */
  background: rgb(var(--red), var(--green), var(--blue));

  /* calculates perceived lightness using the sRGB Luma method
    Luma = (red * 0.2126 + green * 0.7152 + blue * 0.0722) / 255 */
  --r: calc(var(--red) * 0.2126);
  --g: calc(var(--green) * 0.7152);
  --b: calc(var(--blue) * 0.0722);
  --sum: calc(var(--r) + var(--g) + var(--b));
  --perceived-lightness: calc(var(--sum) / 255);

  /* shows either white or black color depending on perceived darkness */
  color: hsl(
    0,
    0%,
    calc((var(--perceived-lightness) - var(--threshold)) * -10000000%)
  );
}

.release-row {
  background: var(--light-4);
  height: 34px;
  padding: 0 12px 0 16px;
  color: var(--text-dark);
  font-size: 12px;
  font-weight: 500 !important;
  line-height: 100%; /* 12px */
  letter-spacing: -0.42px;
  position: relative;
}

.release-add-btn {
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
}

.description-column {
  min-width: 300px;
  max-width: 30vw;
  z-index: 0;
}

.v-tooltip__content {
  background: var(--light-1);
  color: var(--color-primary);
  border-radius: 10px;
}

.v-tooltip__content code {
  background: var(--color-primary);
  color: white;
}

.sortable-chosen {
  background: #eee;
}

.sortable-ghost {
  background: #E5E3E1;
}

.sortable-ghost > td {
  opacity: 0.01;
}

[data-theme="dark"] .sortable-chosen {
  background: var(--light-3);
}

[data-theme="dark"] .sortable-ghost {
  background: var(--light-3);
}

.white-background-on-hover:hover {
  background: var(--light-1) !important;
}

.table-btn {
  background-color: var(--background) !important;
}

:deep(.v-table__wrapper) {
  padding-bottom: 2px;
}

.release-name-display {
  display: inline-block;
  font-weight: 500;
}
</style>

<style>
.hide-first-column .v-data-table__td:first-child {
  display: none;
}
</style>
